import type { BaseComponent } from '@libs/ui/ds/lib/internals'
import { cva } from 'class-variance-authority'
import type { FC, HTMLAttributes, PropsWithChildren } from 'react'
import React from 'react'

const topNavbarLeftCVA = cva(['flex h-full shrink-0 items-center gap-2'])

type Props = BaseComponent & PropsWithChildren & HTMLAttributes<HTMLDivElement>

export const TopNavbarLeft: FC<Props> = ({ children, className, ...other }) => {
  return (
    <div className={topNavbarLeftCVA({ className })} {...other}>
      {children}
    </div>
  )
}
